import type { FC } from "react";
import React from "react";
import { useBrand, useTranslation } from "@edreamsodigeo/frontend-core";

import { logoDimensions } from "~/components/common/PrimeLogo/constants/dimensions";
import { logoSrcMap } from "~/components/common/PrimeLogo/constants/images";
import type { PrimeLogoProps } from "~/components/common/PrimeLogo/contract";

const PrimeLogo: FC<PrimeLogoProps> = ({
  negative,
  size,
  type,
  trackingTitleId,
}) => {
  const brand = useBrand();
  const { t } = useTranslation();
  const dimensions =
    logoDimensions[brand]?.[type]?.[size] || logoDimensions["ED"][type][size];
  const alt = t("variables.brand.name.prime");
  const src =
    logoSrcMap[brand === "GO" ? "GV" : brand]?.[
      negative ? "negative" : "default"
    ]?.[type] || logoSrcMap["ED"][negative ? "negative" : "default"][type];
  return (
    <img
      src={src}
      alt={alt}
      width={dimensions.width}
      height={dimensions.height}
      {...(trackingTitleId && {
        "data-element-id": trackingTitleId,
        "data-testid": trackingTitleId,
      })}
    />
  );
};

export default PrimeLogo;
